import type { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import type { Pog } from "@CommonTypes/merchflow/pog/pog";
import type { StoreDetail } from "./PageMerchflows_ExportPdf_StorePogId";
import { SingleBayPage } from "./SingleBayPage";
import type { A4Page } from "./types";

interface SingleBayPagesListProps {
  singleBayPagesFlat: Array<{
    bay: PlanogramBay;
    page: A4Page;
    index: number;
  }>;
  storeDetail: StoreDetail | null;
  scaleX: number;
  scaleY: number;
  pog: Pog;
  totalPages: number;
}

export const SingleBayPagesList = ({
  singleBayPagesFlat,
  storeDetail,
  scaleX,
  scaleY,
  pog,
  totalPages,
}: SingleBayPagesListProps) => {
  if (!scaleX || !scaleY) {
    return null;
  }

  return (
    <>
      {singleBayPagesFlat.map(({ bay, page, index }, flatIndex) => {
        const pageNumber = flatIndex + 2;
        return (
          <SingleBayPage
            key={`${bay.uniqueId}-${index}`}
            storeDetail={storeDetail}
            section={bay.getNo()}
            slide={index + 1}
            totalSection={pog.planogram.bays.length}
            bayId={bay.uniqueId}
            page={page}
            scaleX={scaleX}
            scaleY={scaleY}
            pog={pog}
            pageNumber={pageNumber}
            totalPages={totalPages}
          />
        );
      })}
    </>
  );
};
